import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { useChecklist } from 'api/useChecklist';
import { useChecklistState } from 'state/hooks/setup-checklist.hook';

import { SetupChecklistContent } from './Content';

export const SetupChecklistContainer: React.FC = () => {
  const location = useLocation();
  const publisherId = location.pathname.split('/project/')[1]?.split('/')[0];

  const { setTasksFromStatusList, hasCategories } = useChecklistState(true);

  const { getTasks } = useChecklist(publisherId, true);

  useEffect(() => {
    setTasksFromStatusList(getTasks.data);
  }, [getTasks.data, setTasksFromStatusList]);

  if (!publisherId || !hasCategories) {
    return null;
  }

  return <SetupChecklistContent />;
};
